module.exports = __webpack_public_path__ + "flyer_background_astronaut_076-47c70f0ef5b2fc441edeedc22252828e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_astronaut_076.jpg
// module id = 1598
// module chunks = 1